import React from 'react';

const CampaignServices = ({ id = 'servicos', ariaLabel, blocks, onCtaClick }) => (
  <section id={id} className="hhc-servicos" aria-label={ariaLabel}>
    {blocks.map((block, blockIndex) => (
      <React.Fragment key={block.num}>
        {blockIndex > 0 && <div className="hhc-svc-divider" aria-hidden="true" />}
        <div className={`hhc-svc-block${block.reverse ? ' hhc-svc-block-rev' : ''}`}>
          <div className="hhc-svc-img">
            <img src={block.image} alt={block.imageAlt} loading="lazy" decoding="async" />
            <div className="hhc-svc-img-tab">{block.tab}</div>
          </div>
          <div className={`hhc-svc-body hhc-reveal ${block.revealClass}`}>
            <div className="hhc-svc-n" aria-hidden="true">
              {block.num}
            </div>
            <div className="hhc-kicker">{block.kicker}</div>
            <h3 className="hhc-svc-title">{block.title}</h3>
            <p className="hhc-svc-p">{block.paragraph}</p>
            <ul className="hhc-svc-bullets">
              {block.bullets.map((bullet, bulletIndex) => (
                <li key={bulletIndex} className="hhc-svc-li">
                  <div className="hhc-svc-dot" aria-hidden="true" />
                  <span>{bullet}</span>
                </li>
              ))}
            </ul>
            <a href="#contato" className="hhc-btn hhc-btn-red hhc-svc-cta" onClick={onCtaClick}>
              {block.cta}
            </a>
          </div>
        </div>
      </React.Fragment>
    ))}
  </section>
);

export default CampaignServices;
